import { Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailService } from '../email.service';
import { StudentRequest } from '@generativ/much-smarter-models';
import { ContentfulService } from '../../../../shared/contentful.service';
import { EntryDictionary as EntryHelpDictionary, ExamType, SubjectType } from '@generativ/ms-help-types';
import { Subscription } from 'rxjs';
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap/nav';
import { NgbAccordionDirective, NgbAccordionItem, NgbAccordionHeader, NgbAccordionToggle, NgbAccordionButton, NgbAccordionCollapse, NgbAccordionBody } from '@ng-bootstrap/ng-bootstrap/accordion';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap/collapse';

@Component({
    selector: 'app-lesson-help',
    templateUrl: './lesson-help.component.html',
    styleUrls: ['./lesson-help.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbAccordionDirective, NgbAccordionItem, NgbAccordionHeader, NgbAccordionToggle, NgbAccordionButton, NgbCollapse, NgbAccordionCollapse, NgbAccordionBody, NgbNavOutlet, FormsModule, ReactiveFormsModule]
})
export class LessonHelpComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  askTutorForm: UntypedFormGroup;
  subjects: SubjectType[];
  aCTcontent: ExamType;

  constructor(
    private modalService: NgbModal,
    private emailService: EmailService,
    private fb: UntypedFormBuilder,
    private contentfulService: ContentfulService
  ) {
    this.createFormGroup();
  }

  ngOnInit() {
    this.contentfulService.getHelpEntry(EntryHelpDictionary.Exam.aCT).then(
      (entry) => {
        this.aCTcontent = new ExamType(entry);
      },
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  open(content) {
    this.modalService.open(content, { windowClass: 'help-modal' });
  }

  public sendEmail() {
    const question = new StudentRequest.AskTutor();
    question.body = this.askTutorForm.value.helpMessage;
    this.subscriptions.add(this.emailService.sendAskTutorEmail(question).subscribe(
      feedbackModel => {
        console.log('feedbackModel', feedbackModel);
      },
      error => {
        console.log(error);
      }
    ));
  }

  private createFormGroup() {
    this.askTutorForm = this.fb.group({
      helpMessage: [
        null,
        Validators.required
      ],
    });
  }


}
